import * as v from "valibot";

export const taskSearchSchema = v.object({
  openTaskId: v.optional(v.string()),
  openTaskTab: v.optional(v.picklist(["details", "notes"])),
  openAgendaItemId: v.optional(v.string()),
});

export type TaskSearchSchema = v.InferOutput<typeof taskSearchSchema>;
